export default __webpack_public_path__ + "static/media/92.b1c516b6.jpeg";